import { h, render, Component } from 'preact'; // eslint-disable-line no-unused-vars

export default () => {
  Array.from(document.getElementsByTagName('ArrowIcon')).forEach((el) => {
    el.setAttribute('class', 'icon-wrapper');
    render((
      <svg className="icon icon__arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.21 28.09">
        <path className="foreground" d="M14.52,14.66a.57.57,0,0,1-.4-.16L.22,1.07A.58.58,0,0,1,1,.24H1L14.92,13.67a.58.58,0,0,1,0,.81A.55.55,0,0,1,14.52,14.66Z"/>
        <path className="foreground" d="M.62,28.09a.58.58,0,0,1-.42-.17.58.58,0,0,1,0-.82L14.12,13.67a.58.58,0,0,1,.8.83L1,27.93A.57.57,0,0,1,.62,28.09Z"/>
      </svg>
    ), el);
  });
};
